import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { MAX_WIDTH } from '../../../../web-ui/src/layout/PageWrapper.style';

export const Container = styled.div`
  background-color: ${(props) => props.theme.backgroundLightest};
`;

export const Content = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (${laptopMediumMax}) {
    padding: 20px 15px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ButtonsRow = styled.div`
  display: flex;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.primaryTranslucent};
`;

export const ItemRow = styled.a`
  display: flex;
  align-items: center;
  padding: 20px 0;
  margin-right: 30px;

  p {
    font-size: 16px;
    color: ${(props) => props.theme.primary};
    text-decoration: underline;
    margin-left: 10px;
    transition: 300ms all;
  }

  &:hover p {
    color: ${(props) => props.theme.backgroundMid};
  }
`;

export const DropButtonWrapper = styled.div`
  position: relative;
`;

export const DropOptions = styled.div`
  position: absolute;
  width: 100%;
  top: 60px;
  background-color: ${({ theme }) => theme.background};
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 5;

  button,
  a {
    display: block;
    width: 100%;
    padding: 15px;
    font-size: 16px;
    text-align: left;
    color: ${(props) => props.theme.textDark};

    &:hover {
      background-color: ${({ theme }) => theme.backgroundLightest};
    }
  }
`;
